module.exports = __webpack_public_path__ + "media/ui/events/travelhero2-7521afd7ebffff7aa9453a10d6bc9147.png";